import { mode, transparentize } from '@chakra-ui/theme-tools';
const baseStyle = (props) => {
    const { theme, colorScheme } = props;
    return {
        control: {
            borderColor: mode(transparentize('gray.500', 0.5)(theme), transparentize('gray.300', 0.5)(theme))(props),
            _hover: {
                bg: mode(transparentize('gray.500', 0.1)(theme), transparentize('gray.300', 0.1)(theme)),
                _disabled: {
                    bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                },
            },
            _focus: {
                boxShadow: 'none',
            },
            _active: {
                bg: mode(transparentize('gray.500', 0.3)(theme), transparentize('gray.300', 0.3)(theme)),
            },
            _checked: {
                bg: mode(`${colorScheme}.500`, `${colorScheme}.300`)(props),
                borderColor: mode(`${colorScheme}.500`, `${colorScheme}.300`)(props),
                _hover: {
                    bg: mode(`${colorScheme}.600`, `${colorScheme}.200`)(props),
                    borderColor: mode(`${colorScheme}.600`, `${colorScheme}.200`)(props),
                },
                _active: {
                    bg: mode(`${colorScheme}.700`, `${colorScheme}.100`)(props),
                    borderColor: mode(`${colorScheme}.700`, `${colorScheme}.100`)(props),
                },
                _disabled: {
                    borderColor: 'transparent',
                    bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                    color: mode(transparentize('gray.900', 0.3)(theme), transparentize('gray.0', 0.3)(theme))(props),
                },
            },
            _indeterminate: {
                bg: mode(`${colorScheme}.500`, `${colorScheme}.300`)(props),
                borderColor: mode(`${colorScheme}.500`, `${colorScheme}.300`)(props),
                _hover: {
                    bg: mode(`${colorScheme}.600`, `${colorScheme}.200`)(props),
                    borderColor: mode(`${colorScheme}.600`, `${colorScheme}.200`)(props),
                },
                _active: {
                    bg: mode(`${colorScheme}.700`, `${colorScheme}.100`)(props),
                    borderColor: mode(`${colorScheme}.700`, `${colorScheme}.100`)(props),
                },
                _disabled: {
                    borderColor: 'transparent',
                    bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                    color: mode(transparentize('gray.900', 0.3)(theme), transparentize('gray.0', 0.3)(theme))(props),
                },
            },
            _disabled: {
                bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                borderColor: 'transparent',
            },
        },
    };
};
const sizes = {
    md: {
        control: { width: 4, height: 4 },
        label: { fontSize: 'md' },
        icon: {
            fontSize: 'xs',
        },
    },
    lg: {
        control: { width: 5, height: 5 },
        Label: { fontSize: 'lg' },
        icon: {
            fontSize: 'xs',
        },
    },
};
const defaultProps = {
    colorScheme: 'green',
};
export default {
    baseStyle,
    sizes,
    defaultProps,
};
//# sourceMappingURL=checkbox.js.map